/**
 * @generated SignedSource<<9b5ac1fd3f6c279f2acefae882bb05e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanyRecommendationsList_organization$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AverageCompanyReviewScoreBreakdown_organization" | "OverviewRecommendationsSectionEmptyState_organization">;
  readonly " $fragmentType": "CompanyRecommendationsList_organization";
};
export type CompanyRecommendationsList_organization$key = {
  readonly " $data"?: CompanyRecommendationsList_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyRecommendationsList_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompanyRecommendationsList_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AverageCompanyReviewScoreBreakdown_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OverviewRecommendationsSectionEmptyState_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "5938e24380aff0a41dfe297b27a62cf5";

export default node;
